module.exports = __webpack_public_path__ + "static/media/header_03_mobil.8ad31eaa.jpg";